<template>
  <div class="alert-message">
    <v-alert
      :value="hasError"
      :type="type"
      :icon="icon"
      :color="colors[type]"
      :dismissible="dismissible"
      @input="onInput($event)"
    >
      <span :class="`text-${type}`">{{ message }}</span>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'AlertMessage',
  props: {
    error: {
      type: [Object, String],
      default() {
        return {};
      },
    },
    type: {
      default: 'error',
      validator: (value) => ['success', 'info', 'warning', 'error'].indexOf(value) !== -1,
    },
    icon: {
      type: String,
      default: '',
    },
    defaultMessage: {
      type: String,
      default: '',
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      colors: {
        success: 'success',
        info: 'info',
        warning: 'warning',
        error: 'error',
      },
    };
  },
  computed: {
    hasError() {
      return !!this.message;
    },
    message() {
      if (Object.keys(this.error).length < 1) {
        return '';
      }
      return this.getError(this.error);
    },
  },
  methods: {
    onInput() {
      this.$emit('update:error', {});
    },
    getError(error) {
      return (
        error.message || this.defaultMessage || this.$t('support.components.alert.serverError')
      );
    },
  },
};
</script>

<style scoped>
.alert-message .v-icon {
  color: #fff6e8 !important;
}
</style>
